var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2674400"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.714844 19.582031 L 2.714844 0.417969 L 12.90625 0.417969 L 17.285156 4.792969 L 17.285156 19.582031 Z M 2.714844 19.582031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 12.75 0.800781 L 16.898438 4.949219 L 16.898438 19.199219 L 3.101562 19.199219 L 3.101562 0.800781 L 12.75 0.800781 M 13.066406 0.0351562 L 2.332031 0.0351562 L 2.332031 19.964844 L 17.667969 19.964844 L 17.667969 4.632812 Z M 13.066406 0.0351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.683594 5.015625 L 12.683594 0.417969 L 12.90625 0.417969 L 17.285156 4.792969 L 17.285156 5.015625 Z M 12.683594 5.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 13.066406 1.117188 L 16.582031 4.632812 L 13.066406 4.632812 L 13.066406 1.117188 M 13.066406 0.0351562 L 12.300781 0.0351562 L 12.300781 5.398438 L 17.667969 5.398438 L 17.667969 4.632812 Z M 13.066406 0.0351562 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ae1d4d8a.svg";
export { ForwardRef as ReactComponent };